import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '../components/VerifyOTP';

class VerifyOTP extends Component {
  constructor() {
    super();
    this.state = { error: null, success: null, loading: false, message: null };
  }

  /**
   * On Form Submission
   */
  onFormSubmit = async (data) => {
    const { verifyOTP } = this.props;

    this.setState({ success: null, error: null, loading: true, message: null });

    try {
      const { success, message } = await verifyOTP(data);
      this.setState({ success, error: null, loading: false });
      if (success) {
        this.setState({
          success,
          error: null,
          loading: false,
          message:
            'We have sent you an email to your registered email address with a link to set your new password. Please check your email and follow the link to set your new password.',
          verified: true,
        });
        // setTimeout(() => {
        //   history.push('/');
        // }, 1000);
      } else {
        this.setState({ success, error: true, loading: false, message });
      }
    } catch (error) {
      this.setState({ loading: false, success: null, error: error.message });
    }
  };

  /**
   * Resend OTP
   */
  resendOTP = async () => {
    const { onResendOTP, userInput } = this.props;

    this.setState({ success: null, error: null, loading: true });

    try {
      const { success } = await onResendOTP(userInput);
      if (success) {
        this.setState({ success, message: 'New OTP has been sent.', error: null, loading: false });
      } else {
        this.setState({ success, error: true, message: 'Failed !!', loading: false });
      }
    } catch (error) {
      this.setState({ loading: false, success: null, error: error.message });
    }
  };

  /**
   * Render
   */
  render = () => {
    const { userInput } = this.props;
    const { error, loading, success, message, verified } = this.state;

    return (
      <Layout
        verified={verified}
        error={error}
        loading={loading}
        success={success}
        message={message}
        defaultValues={userInput}
        onFormSubmit={this.onFormSubmit}
        resendOTP={this.resendOTP}
      />
    );
  };
}

VerifyOTP.propTypes = {
  userInput: PropTypes.shape({}).isRequired,
  verifyOTP: PropTypes.func.isRequired,
  onResendOTP: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  userInput: {
    phone_number: state.member.phoneNumber,
    masked_phone_number: state.member.maskedPhoneNumber,
    user_id: state.member.userID,
    first_name: state.member.firstName,
    last_name: state.member.lastName,
  },
});

const mapDispatchToProps = (dispatch) => ({
  verifyOTP: dispatch.member.verifyOTP,
  onResendOTP: dispatch.member.resendOTP,
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyOTP);
